import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuardService } from './core/services/util/role-guard.service'
import { TicketComponent } from './ui/components/util/ticket/ticket.component'
import { CategoriesComponent } from './ui/pages/categories/categories.component'
import { DashboardComponent } from './ui/pages/dashboard/dashboard.component'
import { EgresosComponent } from './ui/pages/egresos/egresos.component'
import { HomePageComponent } from './ui/pages/home-page/home-page.component'
import { IngresosPageComponent } from './ui/pages/ingresos-page/ingresos-page.component'
import { LoginComponent } from './ui/pages/login/login.component'
import { PettyComponent } from './ui/pages/petty/petty.component'
import { CashFlowSimpleComponent } from './ui/pages/reports/cash-flow-simple/cash-flow-simple.component'
import { CashFlowComponent } from './ui/pages/reports/cash-flow/cash-flow.component'
import { DailyCutComponent } from './ui/pages/reports/daily-cut/daily-cut.component'
import { MensualBalanceComponent } from './ui/pages/reports/mensual-balance/mensual-balance.component'
import { ServicesComponent } from './ui/pages/reports/services/services.component'
import { SubcategoriesComponent } from './ui/pages/subcategories/subcategories.component'
import { LocationsComponent } from './ui/pages/locations/locations.component'

const routes: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: '',
        component: DashboardComponent,
        canActivate: [AuthGuardService],
        children: [
            { path: '', component: HomePageComponent },
            { path: 'ingresos', component: IngresosPageComponent },
            { path: 'egresos', component: EgresosComponent },
            { path: 'corte-diario', component: DailyCutComponent },
            { path: 'reporte-mensual', component: MensualBalanceComponent },
            { path: 'historico-servicios', component: ServicesComponent },
            { path: 'flujo-efectivo', component: CashFlowComponent },
            {
                path: 'flujo-efectivo-simple',
                component: CashFlowSimpleComponent,
            },
            { path: 'cantidad-entregada', component: PettyComponent },
        ],
    },
    {
        path: 'admin',
        component: DashboardComponent,
        canActivate: [AuthGuardService],
        children: [
            { path: 'categories', component: CategoriesComponent },
            { path: 'subcategories', component: SubcategoriesComponent },
            { path: 'locations', component: LocationsComponent },
        ],
    },
    { path: 'receipt', component: TicketComponent },
]

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
